import { VideoPlayer } from './parts/video-player'

const $body = $('body')

//const videoPlayer = new VideoPlayer($('#video-player video')[0])

$body.on('click', '.video-play', function () {
  videoPlayer.play()
})

$body.on('click', '.video-pause', function () {
  videoPlayer.pause()
})

